const Isotope = require("isotope-layout");

const Faq = document.querySelector(".faq");
const filtersElem = document.querySelector(".filterBtnGroup");
const filterBtns = document.querySelectorAll(".filterBtn");

if (Faq) {
	window.addEventListener("load", () => {
		let iso = new Isotope(Faq, {
			// options
			itemSelector: ".faq-item",
			layoutMode: "fitRows",
			filter: ".open",
			getSortData: {
				open: ".open",
			},
		});

		if (filtersElem) {
			// bind filter button click
			filtersElem.addEventListener("click", (e) => {
				let filterValue = e.target.getAttribute("data-filter");

				iso.arrange({
					filter: filterValue,
					sortBy: "open",
					// sortAscending: false¿
				});
			});
		}

		filterBtns.forEach((item) => {
			item.addEventListener("click", () => {
				filterBtns.forEach((item) => {
					item.classList.remove("is-active");
				});

				item.classList.add("is-active");
			});
		});
	});
}
